import { SingleButton } from "../../../../API/Buttons/models"

export const getStaticIconName = (button: SingleButton | null) => {
    if (!button) return ''
    if (button?.name === "static_reset") { return "Reestablecer" }
    if (button?.name === "static_unblock") { return "Desbloquear" }
    if (button?.name === "static_bonus") { return "Bonificación" }
    if (button?.name === "static_subtract") { return "Bajar" }
    if (button.name === "static_add") { return "Cargar" }
    if (button.name === "static_newuser") { return "Nuevo Usuario (Desde el Bot)" }
    if (button.name === "static_history") { return "Historial" }
    if (button.name === "static_newplayerbyemail") { return "Crear en Gestor y Plataforma (Desde sección Jugadores)" }
    if (button.name === "static_newplayer") { return "Crear jugador en Gestor (Desde sección Jugadores)" }
    return button.name;
}

export const getStaticIconCategory = (button: SingleButton | null) => {
    if (!button) return ''
    if (button?.name === "static_reset") { return "Botón de acción (No se puede editar)" }
    if (button?.name === "static_unblock") { return "Botón de acción (No se puede editar)" }
    if (button?.name === "static_bonus") { return "Botón de acción (No se puede editar)" }
    if (button?.name === "static_subtract") { return "Botón de acción (No se puede editar)" }
    if (button.name === "static_add") { return "Botón de acción (No se puede editar)" }
    if (button.name === "static_newuser") { return "Botón de acción (No se puede editar)" }
    if (button.name === "static_history") { return "Botón de acción (No se puede editar)" }
    if (button.name === "static_newplayerbyemail") { return "Botón de acción (No se puede editar)" }
    if (button.name === "static_newplayer") { return "Botón de acción (No se puede editar)" }

    return `Categoría: ${button.category}`;
}


